import React from "react";
import styled from "styled-components";
import { Loading } from "../Loading";
const Styles = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0.2rem 0;
  &.smaller {
    .text-btn {
      border-radius: 8px;
    }
  }
  .text-btn {
    cursor: pointer;
    text-decoration: none;
    background: var(--prime-2);
    border: 1px solid var(--prime-2);
    padding: 15px 30px;
    text-align: center;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
    font-size: var(--fs-btn);
    color: var(--fsc-d-1);
    text-align: center;
    border-radius: 8px;
    width: max-content;
    width: 100%;
    color: var(--grey-1);
    :hover {
      background-color: var(--prime-2-o);
    }
    :disabled {
      background-color: #E5E5E5aa;
      border: 1px solid #E5E5E51f;
    }
  }
  .error {
    display: flex;
    height: 1rem;
    font-size: var(--fs-small);
    .icon {
      text-align: center;
      width: 1rem;
      height: 1rem;
    }
    .text {
      margin: 0 0.2rem 0 0;
    }
  }
  @media screen and (max-width: 1445px) {
    .text-field {
      padding: 0.7rem 1rem;
    }
  }
`;

export const TextBtn = ({
  style,
  className,
  type,
  name,
  text,
  onclick,
  disabled,
  loading,
  newType1,
}) => {
  let classes = "text-btn";
  if(newType1) {
    classes+= " btn-type-1"
  }
  if (loading) {
    return (
      <Styles style={style} className={className}>
        <button
          type={type}
          className={classes + ' ' +className}
          name={name}
          onClick={onclick}
          disabled={disabled}
        >
          <Loading />
        </button>
      </Styles>
    );
  }
  return (
    <Styles style={style} className={className}>
      <button
        type={type}
        className={classes}
        name={name}
        onClick={onclick}
        disabled={disabled}
      >
        {text}
      </button>
    </Styles>
  );
};
